import styled from 'styled-components'

const Container = styled.div`
  position: relative;
`

const SwitchContainer = styled.div`
  &:first-child {
    border-top: 1px solid ${props => props.theme.color.monochrome.light};
    padding-top: 10px;
    margin-top: 10px;

    ${props =>
      props.PDP_V2_FLAG &&
      `
      border-top: none;
      margin-top: 0;
      padding-top: 0;
    `}
  }
`

export { Container, SwitchContainer }
